"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BooleanValue = void 0;
var BooleanValue;
(function (BooleanValue) {
    BooleanValue.Values = {
        TRUE: '$_BOOL_true',
        FALSE: '$_BOOL_false',
    };
    function toNative(value) {
        const type = typeof value;
        switch (true) {
            case value === undefined:
                return false;
            case type === 'boolean':
                return value;
            case value === BooleanValue.Values.TRUE:
                return true;
            case value === '':
            case value === null:
            case value === BooleanValue.Values.FALSE:
                return false;
        }
        throw new TypeError(`Cannot convert value of type ${type} with value "${value}" to BooleanValue`);
    }
    BooleanValue.toNative = toNative;
    function toTransientString(src) {
        if (typeof src === 'string') {
            return src === 'Yes' ? BooleanValue.Values.TRUE : BooleanValue.Values.FALSE;
        }
        else {
            return src ? BooleanValue.Values.TRUE : BooleanValue.Values.FALSE;
        }
    }
    BooleanValue.toTransientString = toTransientString;
})(BooleanValue || (exports.BooleanValue = BooleanValue = {}));
